export default __webpack_public_path__ + "static/media/12-min.78ac28ab.jpg";